import {IfBox} from "../../../../../style/if";
import * as React from "react";
import {Icon, Popup} from "semantic-ui-react";
import {decorators, Treebeard} from 'react-treebeard';


export interface CustomNavTreeProps {
    data: any
    onToggle: (node, toggled) => void
}

export function CustomNavTree(props: React.PropsWithChildren<CustomNavTreeProps>) {
    decorators.Header = CustomHeader

    if (props.data != null) {
        //console.log("drawTree: ", data)
        return (
            <Treebeard
                data={props.data}
                onToggle={props.onToggle}
                decorators={decorators}
            />
        );
    } else {
        return <h2>no config found</h2>
    }

}

function drawDeprecatedWarningIfNeededOnNode(node) {
    return <IfBox shouldShow={node.isDeprecated}><Popup content={"DEPRECATED: " + node.deprecatedMessage} trigger={
        <Icon name="exclamation triangle" color="yellow"/>
    }
    /></IfBox>
}

const displayName = (node) => {
    if(node.displayName != null) {
        return node.displayName
    }
    return node.name
}

const getNodeTitleStyle = (node, style) => {
    if (node.active && node.isEdited) {
        return {...style.title, display: "flex", fontWeight: "bold", color: "#f7d24b"}
    }
    if (node.isEdited) {
        return {...style.title, display: "flex", fontWeight: "bold", color: "orange"}
    }
    if (node.active) {
        return {...style.title, display: "flex", fontWeight: "bold", color: "lightgreen"}
    }
    return {...style.title, display: "flex"}
}

const CustomHeader = ({node, style, prefix}) => (

    <div style={style.base}>
        <div style={getNodeTitleStyle(node, style)}>
            {drawDeprecatedWarningIfNeededOnNode(node)}{displayName(node)}
        </div>
        <IfBox shouldShow={node.active && node.isEdited}>
            <Icon name="search" color="grey" size="small"/>
        </IfBox>
    </div>
);
